import api from './api';

export const customerService = {
  async list({ page = 1, limit = 10, search = '' } = {}) {
    const response = await api.get('/customers', {
      params: { page, limit, ...(search && { search }) }
    });
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/customers/${id}`);
    return response.data.data;
  },

  async create(data) {
    const response = await api.post('/customers', data);
    return response.data.data;
  },

  async update(id, data) {
    const response = await api.put(`/customers/${id}`, data);
    return response.data.data;
  },

  async delete(id) {
    const response = await api.delete(`/customers/${id}`);
    return response.data.data;
  },

  async getCustomerQuotes(customerId) {
    const response = await api.get('/quotes', {
      params: { customerId }
    });
    return response.data;
  },
};